import { Country, Roles } from '@shs-digi-care-monorepo/interfaces';
import { Stage } from '@shs-digi-care-monorepo/frontend-lib/enums';

/**
 * All country- and role-gated features in the EMEA module.
 * Add new entries here when introducing new country- or role-specific features.
 */
export enum EmeaFeature {
    /** Instrument Delivery tile on the landing page (AT internal only) */
    INSTRUMENT_DELIVERY = 'INSTRUMENT_DELIVERY',
    /** Purchase Order tile and request type (AT, NL internal only) */
    PURCHASE_ORDER = 'PURCHASE_ORDER',
    /** Esker integration for sending requests to Esker */
    ESKER = 'ESKER',
    /** Access to the admin area as a whole */
    ADMIN_AREA = 'ADMIN_AREA',
    /** User Management */
    USER_MANAGEMENT = 'USER_MANAGEMENT',
    /** Team Management incl. escalation managers and request distribution */
    TEAM_MANAGEMENT = 'TEAM_MANAGEMENT',
    /** Request types and classifications */
    REQUEST_TYPE_MANAGEMENT = 'REQUEST_TYPE_MANAGEMENT',
    /** Translation Management */
    TRANSLATION_MANAGEMENT = 'TRANSLATION_MANAGEMENT',
    /** Admin rule set */
    RULE_SET_MANAGEMENT = 'RULE_SET_MANAGEMENT',
    /** VIP/priority customers */
    PRIORITY_MANAGEMENT = 'PRIORITY_MANAGEMENT',
    /** Maintaining one's own absences */
    OUT_OF_OFFICE = 'OUT_OF_OFFICE',
    /** Out-of-office calendar across the teams in scope */
    OUT_OF_OFFICE_CALENDAR = 'OUT_OF_OFFICE_CALENDAR',
    /** Country Switcher */
    COUNTRY_SWITCHER = 'COUNTRY_SWITCHER'
}

/**
 * Feature configuration entry defining which countries and roles can access a feature.
 */
export interface FeatureConfig {
    /** Countries for which the feature is enabled. Omit to enable it for all EMEA countries. */
    countries?: Country[];
    /** Roles that have access to this feature. Empty array means all roles have access. */
    roles: Roles[];
    /** Whether the feature is limited to Siemens Healthineers internal users. */
    internalOnly?: boolean;
    /** Optional: feature is disabled on these stages */
    disabledOnStages?: Stage[];
}
